import React from 'react';

import { Flex, CircularProgress } from '@chakra-ui/react';

export function LoadingIndicator() {
  return (
    <Flex
      w="100%"
      h="100%"
      flex={1}
      alignSelf="stretch"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress isIndeterminate />
    </Flex>
  );
}
